import { Label } from './Styled'

const SplashVersionNumber = () => {
  return <Label>{process.env.REACT_APP_VERSION}</Label>
}

export default SplashVersionNumber
